var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as AddBackorderDemand from "@ori-events/add-backorder-demand";
import * as AddBasketOffer from "@ori-events/add-basket-offer";
import * as AddCustomerOrder from "@ori-events/add-customer-order";
import * as AddToBasket from "@ori-events/add-to-basket";
import * as AddVoucher from "@ori-events/add-voucher";
import * as BasketUpdated from "@ori-events/basket-updated";
import * as CancelBackorderDemand from "@ori-events/cancel-backorder-demand";
import * as ClearBasket from "@ori-events/clear-basket";
import * as DelaySubscription from "@ori-events/delay-subscription";
import * as LoyaltyDialogResult from "@ori-events/loyalty-dialog-result";
import * as PlaceOrderRequested from "@ori-events/place-order-requested";
import * as RemoveBasketItem from "@ori-events/remove-basket-item";
import * as RemoveCustomerOrder from "@ori-events/remove-customer-order";
import * as RemoveVoucher from "@ori-events/remove-voucher";
import * as ReplaceShoppingBagItem from "@ori-events/replace-shopping-bag-item";
import * as RequestShoppingContext from "@ori-events/request-shopping-context";
import * as ResetShippingSelection from "@ori-events/reset-shipping-selection";
import { ShoppingContextLoadedEvent } from "@ori-events/shopping-context-loaded";
import * as UpdateBasketItem from "@ori-events/update-basket-item";
import * as UpdateCustomerOrderItem from "@ori-events/update-customer-order-item";
import * as UpdateOfferItem from "@ori-events/update-offer-item";
import * as UpdateOfferItems from "@ori-events/update-offer-items";
import addBackorderDemandHandler from "./handlers/addBackorderDemandHandler";
import addBasketOfferHandler from "./handlers/addBasketOfferHandler";
import addCustomerOrderHandler from "./handlers/addCustomerOrderHandler";
import addToBasketHandler from "./handlers/addToBasketHandler";
import addVoucherHandler from "./handlers/addVoucherHandler";
import cancelBackorderDemandHandler from "./handlers/cancelBackorderDemandHandler";
import checkLoyaltyDialogResultAndAddToBasketHandler from "./handlers/checkLoyaltyDialogResultAndAddToBasketHandler";
import clearBasketHandler from "./handlers/clearBasketHandler";
import delaySubscriptionHandler from "./handlers/delaySubscriptionHandler";
import removeCustomerOrderHandler from "./handlers/removeCustomerOrderHandler";
import removeFromBasketHandler from "./handlers/removeFromBasketHandler";
import removeVoucherHandler from "./handlers/removeVoucherHandler";
import replaceShoppingBagItemHandler from "./handlers/replaceShoppingBagItemHandler";
import requestShoppingContextHandler from "./handlers/requestShoppingContextHandler";
import resetShippingSelectionHandler from "./handlers/resetShippingSelectionHandler";
import updateBasketItemHandler from "./handlers/updateBasketItemHandler";
import updateCustomerOrderItemHandler from "./handlers/updateCustomerOrderItemHandler";
import updateOfferItemHandler from "./handlers/updateOfferItemHandler";
import updateOfferItemsHandler from "./handlers/updateOfferItemsHandler";
import { dispatchBasketUpdatedEvent, log, logReceivedEvent } from "./helpers";
import { contextKey, getItem, isStorageAvailable, listenToStoredItemChanges, removeItem, setItem, } from "./helpers/storage";
var getCachedContext = function () { return getItem(contextKey); };
var setCachedContext = function (value) {
    return setItem(contextKey, value);
};
var clearCachedContext = function () { return removeItem(contextKey); };
export var contextUpdatesMap = [
    [AddBackorderDemand.Name, addBackorderDemandHandler],
    [AddBasketOffer.Name, addBasketOfferHandler],
    [AddCustomerOrder.Name, addCustomerOrderHandler],
    [AddToBasket.Name, addToBasketHandler],
    [AddVoucher.Name, addVoucherHandler],
    [CancelBackorderDemand.Name, cancelBackorderDemandHandler],
    [ClearBasket.Name, clearBasketHandler],
    [DelaySubscription.Name, delaySubscriptionHandler],
    [LoyaltyDialogResult.Name, checkLoyaltyDialogResultAndAddToBasketHandler],
    [RemoveBasketItem.Name, removeFromBasketHandler],
    [RemoveCustomerOrder.Name, removeCustomerOrderHandler],
    [RemoveVoucher.Name, removeVoucherHandler],
    [ReplaceShoppingBagItem.Name, replaceShoppingBagItemHandler],
    [ResetShippingSelection.Name, resetShippingSelectionHandler],
    [UpdateBasketItem.Name, updateBasketItemHandler],
    [UpdateCustomerOrderItem.Name, updateCustomerOrderItemHandler],
    [UpdateOfferItems.Name, updateOfferItemsHandler],
    [UpdateOfferItem.Name, updateOfferItemHandler],
];
var BasketProvider = /** @class */ (function () {
    function BasketProvider() {
        this.isBrowserStorageUsed = false;
        this.isBrowserTabsSynchronizationUsed = false;
        this.isRequestingShoppingContext = false;
        this.parseConfiguration();
        if (this.isBrowserStorageUsed) {
            this.getStoredContext();
        }
        this.initEventListeners();
    }
    BasketProvider.prototype.getConfiguration = function () {
        var _a = this, isBrowserStorageUsed = _a.isBrowserStorageUsed, isBrowserTabsSynchronizationUsed = _a.isBrowserTabsSynchronizationUsed;
        return {
            isBrowserStorageUsed: isBrowserStorageUsed,
            isBrowserTabsSynchronizationUsed: isBrowserTabsSynchronizationUsed,
        };
    };
    BasketProvider.prototype.getContext = function () {
        return this.shoppingContext ? __assign({}, this.shoppingContext) : undefined;
    };
    BasketProvider.prototype.initEventListeners = function () {
        var _this = this;
        contextUpdatesMap.forEach(function (_a) {
            var eventName = _a[0], handler = _a[1];
            var updateHandler = handler;
            var action = function (event) { return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            logReceivedEvent(event);
                            return [4 /*yield*/, updateHandler(event)];
                        case 1:
                            data = _a.sent();
                            if (data === false) {
                                log("Shopping context update failed.");
                            }
                            else {
                                this.updateContext(data, BasketUpdated.Name);
                            }
                            return [2 /*return*/];
                    }
                });
            }); };
            window.addEventListener(eventName, action);
        });
        window.addEventListener(RequestShoppingContext.Name, (function (event) { return __awaiter(_this, void 0, void 0, function () {
            var newData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logReceivedEvent(event);
                        if (this.shoppingContext) {
                            log("Context data was loaded before. Triggering " + ShoppingContextLoadedEvent + " event ...");
                            dispatchBasketUpdatedEvent(this.shoppingContext, ShoppingContextLoadedEvent);
                            return [2 /*return*/];
                        }
                        if (this.isRequestingShoppingContext) {
                            log("Shopping context was already requested. Waiting for response ...");
                            return [2 /*return*/];
                        }
                        log("Loading shopping context ...");
                        this.isRequestingShoppingContext = true;
                        return [4 /*yield*/, requestShoppingContextHandler()];
                    case 1:
                        newData = _a.sent();
                        this.isRequestingShoppingContext = false;
                        log("Shopping context was loaded.");
                        this.updateContext(newData, ShoppingContextLoadedEvent);
                        return [2 /*return*/];
                }
            });
        }); }));
        // This is now called when the user requests creating a new order.
        // That means that the cache should be cleared. But we don't know yet
        // if the create order action succeeds. Getting exact order creation
        // result / success might be problematic, as there are page redirects
        // involved, and after page reload, it is too late for clearing caches.
        // So current solution calls the PlaceOrderRequested event before
        // calling the request on server, so that there is enough time to
        // do this cache cleanup here before the redirects happen.
        // ATM, the redirect is being done in legacy module & this logic might
        // change after rewriting to React.
        window.addEventListener(PlaceOrderRequested.Name, (function (event) {
            logReceivedEvent(event);
            log("Clearing stored shopping context data ...");
            _this.shoppingContext = undefined;
            clearCachedContext();
        }));
        // If there was a change in stored data from another browser tab,
        // if the context value was set, update the context with triggering
        // basket-updated event. Other components need to be informed about
        // the new state & this will not happen on page load, but later.
        // So the basket-updated event should be fine for this.
        if (this.isBrowserTabsSynchronizationUsed) {
            listenToStoredItemChanges(contextKey, function (value) {
                if (value) {
                    _this.updateContext(value, BasketUpdated.Name, false);
                }
            });
        }
        log("Event listeners connected.");
    };
    BasketProvider.prototype.parseConfiguration = function () {
        var _a;
        var configElement = document.getElementById(BasketProvider.CONFIG_ELEMENT_ID);
        var rawData = (_a = configElement === null || configElement === void 0 ? void 0 : configElement.innerHTML) !== null && _a !== void 0 ? _a : "{}";
        log("Raw configuration data:\n\t", rawData);
        var _b = JSON.parse(rawData), 
        // not sure yet if a feature toggle should be created for this
        // default ATM set to true for testing
        _c = _b.useBrowserTabsSynchronization, 
        // not sure yet if a feature toggle should be created for this
        // default ATM set to true for testing
        useBrowserTabsSynchronization = _c === void 0 ? true : _c, 
        // feature toggle
        _d = _b.useLocalStorage, 
        // feature toggle
        useLocalStorage = _d === void 0 ? false : _d;
        this.isBrowserStorageUsed = isStorageAvailable && useLocalStorage;
        this.isBrowserTabsSynchronizationUsed =
            this.isBrowserStorageUsed && useBrowserTabsSynchronization;
        if (configElement) {
            log("Configuration was parsed from element #" + BasketProvider.CONFIG_ELEMENT_ID + ".");
        }
        log("Current configuration:", "\n\tisBrowserStorageUsed:", this.isBrowserStorageUsed, "\n\tisBrowserTabsSynchronizationUsed:", this.isBrowserTabsSynchronizationUsed);
    };
    BasketProvider.prototype.getStoredContext = function () {
        var newData = getCachedContext();
        if (!newData) {
            return;
        }
        this.updateContext(newData, undefined, false);
        log("Restored context data from storage.");
    };
    BasketProvider.prototype.updateContext = function (newData, eventTypeToBeTriggered, shouldStoreData) {
        if (shouldStoreData === void 0) { shouldStoreData = true; }
        // compare old & new state - TODO
        this.shoppingContext = newData;
        if (shouldStoreData && this.isBrowserStorageUsed) {
            setCachedContext(newData);
            log("Stored context was updated with new data:\n\t", newData);
        }
        else {
            log("Context was updated with new data:\n\t", newData);
        }
        if (eventTypeToBeTriggered) {
            log("Triggering " + eventTypeToBeTriggered + " event ...");
            dispatchBasketUpdatedEvent(newData, eventTypeToBeTriggered);
        }
    };
    BasketProvider.CONFIG_ELEMENT_ID = "basket-provider-data";
    return BasketProvider;
}());
export { BasketProvider };
export default BasketProvider;
